module.exports = __webpack_public_path__ + "img/selectPayTypeBtn2.f884382d.png";